(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q4-legal-guarantee-notice"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-q4-legal-guarantee-open]');
    if (open) {
      const dialog = document.getElementById(open.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-q4-legal-guarantee-close]');
    if (close) { const dialog = close.closest('dialog'); if (dialog) dialog.close(); return; }
    if (event.target.matches && event.target.matches('.q4-legal-guarantee__dialog')) event.target.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q4-withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const parisTime = (d) => {
      try { return new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', dateStyle: 'full', timeStyle: 'medium' }).format(d) + ' (heure de Paris)'; }
      catch (e) { return d.toString(); }
    };
    const valueOf = (form, name) => { const el = form.querySelector('[name="' + name + '"]'); return el ? String(el.value || '').trim() : ''; };
    const recapItems = (form) => {
      const label = (input) => { const l = input && form.querySelector('label[for="' + input.id + '"]'); return l ? l.textContent.replace(/\s*\*\s*$/, '').trim() : ''; };
      const items = [];
      form.querySelectorAll('.q4-withdrawal__input').forEach((input) => { const v = String(input.value || '').trim(); if (v) items.push([label(input), v]); });
      const decl = form.querySelector('.q4-withdrawal__declaration input');
      if (decl && decl.checked) items.push(['Déclaration', decl.value]);
      return items;
    };
    const fill = (dl, items) => {
      dl.replaceChildren(...items.map(([k, v]) => { const d = document.createElement('div'); const t = document.createElement('dt'); const dd = document.createElement('dd'); t.textContent = k; dd.textContent = v; d.append(t, dd); return d; }));
    };
    const STORE = 'q4-withdrawal-receipt';

    document.querySelectorAll('form[data-q4-withdrawal]').forEach((form) => {
      const review = form.getAttribute('data-q4-review') === 'true' ? form.querySelector('[data-q4-withdrawal-review]') : null;
      const open = form.querySelector('[data-q4-withdrawal-review-open]');
      const submit = form.querySelector('[data-q4-withdrawal-submit]');
      const order = form.querySelector('[data-q4-withdrawal-order]');
      const ident = form.querySelector('[data-q4-withdrawal-ident]');
      const identify = () => {
        if (!order || !ident) return true;
        const missing = !String(order.value || '').trim() && !String(ident.value || '').trim();
        order.setCustomValidity(missing ? 'Indiquez le numéro de commande ou, à défaut, d’autres éléments d’identification.' : '');
        return !missing;
      };
      if (order && ident) { order.addEventListener('input', identify); ident.addEventListener('input', identify); identify(); }
      if (review && open && submit) {
        open.hidden = false; submit.hidden = true;
        open.addEventListener('click', () => {
          if (!form.reportValidity()) return;
          fill(review.querySelector('[data-q4-withdrawal-recap]'), recapItems(form));
          form.setAttribute('data-q4-reviewing', ''); review.hidden = false; open.hidden = true; submit.hidden = false;
          review.focus();
        });
        review.querySelector('[data-q4-withdrawal-edit]').addEventListener('click', () => {
          form.removeAttribute('data-q4-reviewing'); review.hidden = true; open.hidden = false; submit.hidden = true;
          const first = form.querySelector('.q4-withdrawal__input'); if (first) first.focus();
        });
      }
      const progress = form.querySelector('[data-q4-withdrawal-progress]');
      // S28 : ecoute en phase de capture sur window, AVANT le script hCaptcha de Shopify, qui soumet sinon le formulaire
      // de lui-meme (form.submit()) sans attendre le service d'accuse. Le formulaire est ensuite relache UNE fois
      // (requestSubmit) pour que Shopify et son hCaptcha l'envoient normalement.
      window.addEventListener('submit', (event) => {
        if (event.target !== form) return;
        const stop = () => { event.preventDefault(); event.stopImmediatePropagation(); };
        if (form.hasAttribute('data-q4-release')) { form.removeAttribute('data-q4-release'); return; }
        if (form.hasAttribute('data-q4-sending')) { stop(); return; }
        if (!identify()) { stop(); form.reportValidity(); return; }
        const now = new Date();
        const set = (sel, v) => { const f = form.querySelector(sel); if (f) f.value = v; };
        set('[data-q4-withdrawal-time]', now.toString());
        set('[data-q4-withdrawal-time-paris]', parisTime(now));
        set('[data-q4-withdrawal-time-utc]', now.getUTCFullYear() + '-' + pad(now.getUTCMonth() + 1) + '-' + pad(now.getUTCDate()) + 'T' + pad(now.getUTCHours()) + ':' + pad(now.getUTCMinutes()) + ':' + pad(now.getUTCSeconds()) + 'Z');
        const receipt = { items: recapItems(form), sent: parisTime(now), ack: 'AUCUN', reference: '' };
        const keep = () => { try { sessionStorage.setItem(STORE, JSON.stringify(receipt)); } catch (e) {} };
        keep();
        form.setAttribute('data-q4-sending', '');
        if (submit) { submit.disabled = true; submit.setAttribute('aria-busy', 'true'); }
        // S28 : accuse de reception automatique (service Apps Script). Desactive tant que le reglage ack_endpoint est vide.
        // La reponse est attendue (12 s au plus) puis le formulaire Shopify part DANS TOUS LES CAS (canal de preuve).
        const endpoint = form.getAttribute('data-q4-ack-endpoint');
        if (!endpoint || !/^https:\/\/script\.google\.com\//.test(endpoint) || !window.fetch) return;
        stop();
        if (progress) progress.hidden = false;
        const payload = { nom: valueOf(form, 'contact[Nom]'), prenom: valueOf(form, 'contact[Prénom]'), commande: valueOf(form, 'contact[Numéro de commande]'),
          identification: valueOf(form, 'contact[Autres éléments d’identification]'), email: valueOf(form, 'contact[email]'),
          articles: valueOf(form, 'contact[Articles concernés]'), declaration: (form.querySelector('.q4-withdrawal__declaration input') || {}).value || '',
          envoiParis: valueOf(form, 'contact[Envoi (heure de Paris)]'), envoiUtc: valueOf(form, 'contact[Envoi (UTC)]'), site: (form.querySelector('[data-q4-withdrawal-trap]') || {}).value || '' };
        const ctrl = window.AbortController ? new AbortController() : null;
        const timer = setTimeout(() => { if (ctrl) ctrl.abort(); }, 12000);
        let done = false;
        const finish = () => {
          if (done) return; done = true; clearTimeout(timer);
          set('[data-q4-withdrawal-ref]', receipt.reference);
          set('[data-q4-withdrawal-ack]', receipt.ack === 'ENVOYE' ? 'envoyé par le service automatique' : 'non confirmé : à envoyer par le service client');
          keep();
          form.setAttribute('data-q4-release', '');
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          if (form.hasAttribute('data-q4-release')) { form.removeAttribute('data-q4-release'); HTMLFormElement.prototype.submit.call(form); }
        };
        receipt.ack = 'INCONNU';
        setTimeout(finish, 13000);
        try {
          fetch(endpoint, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
            .then((r) => r.json())
            .then((res) => {
              if (res && res.recu === true && typeof res.reference === 'string' && /^RET-\d{8}-[0-9A-F]{6}$/.test(res.reference)) {
                receipt.reference = res.reference;
                receipt.ack = res.accuse === 'ENVOYE' ? 'ENVOYE' : 'EN_ATTENTE';
              }
            })
            .catch(() => {})
            .then(finish);
        } catch (e) { finish(); }
      }, true);
    });

    // Apres envoi reussi : recapitulatif imprimable, puis effacement immediat des donnees du navigateur.
    const receipt = document.querySelector('[data-q4-withdrawal-receipt]');
    if (receipt) {
      let data = null;
      try { data = JSON.parse(sessionStorage.getItem(STORE) || 'null'); sessionStorage.removeItem(STORE); } catch (e) {}
      if (data && Array.isArray(data.items) && data.items.length) {
        // S28 : phrase sur l'e-mail affirmee seulement si le service a confirme l'envoi de l'accuse.
        const msg = document.querySelector('[data-q4-withdrawal-message]');
        if (msg) {
          const ok = msg.getAttribute('data-q4-ack-ok'), pending = msg.getAttribute('data-q4-ack-pending');
          if (data.ack === 'ENVOYE' && ok) msg.textContent = ok;
          else if ((data.ack === 'EN_ATTENTE' || data.ack === 'INCONNU') && pending) msg.textContent = pending;
        }
        const extra = [['Envoyée le', data.sent]];
        if (data.reference) {
          extra.push(['Référence de la demande', data.reference]);
          const ref = document.querySelector('[data-q4-withdrawal-reference]');
          if (ref) { ref.textContent = 'Référence de votre demande : ' + data.reference; ref.hidden = false; }
        }
        fill(receipt.querySelector('[data-q4-withdrawal-receipt-list]'), data.items.concat(extra));
        receipt.hidden = false;
        receipt.querySelector('[data-q4-withdrawal-print]').addEventListener('click', () => window.print());
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
